import { render, staticRenderFns } from "./FileTxtIcon.vue?vue&type=template&id=7fb65bb6&"
import script from "./FileTxtIcon.vue?vue&type=script&lang=js&"
export * from "./FileTxtIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports